import React from 'react';
import { CtaButton } from '../CtaButton';
import { Countdown } from '../Countdown';
export function FinalCta() {
  return <section className="bg-navy-900 py-16 text-center text-white sm:py-24" aria-labelledby="final-title" data-id="element-117" data-mp="22ckrivsyshci">
      <div className="mx-auto max-w-3xl px-5" data-id="element-118" data-mp="1nogf29ki9226">
        <h2 id="final-title" className="text-balance font-display text-[2rem] font-black leading-tight sm:text-5xl" data-id="element-119" data-mp="1snt1wubdm94r">
          Ready to Stop Improvising and Start Working With a <span className="text-brand-400" data-id="element-120" data-mp="1eqe87de3bf6z">System?</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-lg leading-relaxed text-white/80" data-id="element-121" data-mp="1iqoekr5so7md">
          Start organizing your assessment and treatment planning with a professional framework you can return to
          whenever you need it.
        </p>
        <p className="mt-8 text-sm font-bold uppercase tracking-wider text-white/70" data-id="element-122" data-mp="19r1kkqfea43c">Only</p>
        <p className="font-display text-7xl font-black leading-none sm:text-8xl" data-id="element-123" data-mp="2z2bvdln5bguz">$27</p>

        <CtaButton className="mt-8" tone="dark" label="Get the Hernia Clinical Playbook™" sublabel="Instant Access · Lifetime Access · 7-Day Guarantee" data-id="element-124" data-mp="3415afii2zfx9" />
        <Countdown tone="dark" data-id="element-125" data-mp="3tdbqh5lb7rcd" />
      </div>
    </section>;
}